import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { IInititalState } from '../../reducers/mainReducer';

const WaitingBox: React.FC = () => {

  const {
    waiting,
    notwait
  } = useSelector<{ main: IInititalState }, {
    waiting?: boolean,
    notwait?: boolean
  }>(state => {
    return {
      waiting: state.main.waiting,
      notwait: state.main.notwait
    }
  });

  const memoBody = React.useMemo(() => {
    const show = waiting && !notwait;

    if (!show) return null;

    return (
      <div style={{
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        left: '0px',
        top: '0px',
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: '99999',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center'
      }}>
        <FontAwesomeIcon icon={faSpinner} pulse color='#fff' size='4x' />
        <input type='text' autoFocus inputMode='none' style={{
          width: '0px',
          height: '0px',
          border: '0px',
          padding: '0px',
          position: 'absolute',
          left: '-100px',
          top: '-100px',
          outline: 'none',
          appearance: 'none'
        }} />
      </div>
    );
  }, [waiting, notwait]);

  return (
    <>
      {memoBody}
    </>
  );
}

export { WaitingBox };